import $ from 'jquery';
import './slick';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

document.addEventListener('DOMContentLoaded', function () {
  Sceon.CompanyProfile = {};
  Sceon.CompanyProfile.PagingUrl = '/agencies/paging';

  $('#photos-carousel')?.slick({
    speed: 100,
    infinite: false,
    variableWidth: true,
    draggable: false,
    waitForAnimate: false,
    cssEase: 'linear',
    prevArrow: '.photos-prev',
    nextArrow: '.photos-next',
  });

  $('#profiles-carousel')?.slick({
    speed: 100,
    infinite: false,
    variableWidth: true,
    draggable: false,
    waitForAnimate: false,
    cssEase: 'linear',
    prevArrow: '.profiles-prev',
    nextArrow: '.profiles-next',
  });

  Sceon.CompanyProfile.ParseHash = function () {
    let hash = location.hash.substring(1);
    let filter = {};
    if (!hash.length) {
      return {};
    }
    let params = hash.split(';');
    for (let i in params) {
      let name = params[i].split('=')[0];
      let val = params[i].split('=')[1];
      if (name && val) {
        filter[name] = val;
      }
    }
    return filter;
  };

  Sceon.CompanyProfile.InitPaging = function () {
    if ($('#next-prev').length) {
      let filters = Sceon.CompanyProfile.ParseHash();
      let pid = profileData.refId;
      filters.pid = pid;
      $.ajax({
        method: 'GET',
        url: Sceon.CompanyProfile.PagingUrl,
        data: filters,
        success: function (resp) {
          if (resp) {
            if (resp.previous_id && resp.previous_id === +pid) {
              $('#btn-next').addClass('hidden').attr('data-href', '');
              $('#btn-previous').addClass('hidden').attr('data-href', '');
              return;
            }
            if (resp.next_id) {
              $('#btn-next')
                .removeClass('hidden')
                .attr('href', `/agency/${resp.next_showname}-${resp.next_id}`);
            } else {
              $('#btn-next').addClass('hidden').attr('href', '');
            }
            if (resp.previous_id) {
              $('#btn-previous')
                .removeClass('hidden')
                .attr(
                  'href',
                  `/agency/${resp.previous_showname}-${resp.previous_id}`,
                );
            } else {
              $('#btn-previous').addClass('hidden').attr('href', '');
            }

            if (resp.next_id || resp.previous_id) {
              $('#next-prev').removeClass('hidden');
            }
          }
        },
      });

      function profilePageViewGA(name) {
        let href = $(this).attr('href');
        let hash = document.location.hash.substring(1);
        if (!href || href === '') {
          return;
        }

        new Promise((resolve) => {
          ga('send', 'event', 'companyprofilepage', name, {
            hitCallback: resolve,
          });

          setTimeout(resolve, 1000);
        }).then(() => {
          location.href = `${href}#${hash}`;
        });
      }

      $('#btn-next').click(function () {
        profilePageViewGA.call(this, 'nextbtn_tap');
      });
      $('#btn-previous').click(function () {
        profilePageViewGA.call(this, 'backbtn_tap');
      });
    }
  };

  Sceon.CompanyProfile.InitPaging();

  Sceon.CompanyProfile.InitPhotoViewer = function () {
    $(
      '.carousel-section div.photo-item:not(.next-arrow, .prev-arrow, .slick-cloned)',
    ).click(function (e) {
      e.stopPropagation();
      let index = $(this)
        .closest('.carousel-section')
        .find('div.slick-slide:not(.slick-cloned)')
        .index(this);
      const leftArrowSVGString = `<i class="sc-and6 sc-and6-chevron-right text-white"></i>`;
      const rightArrowSVGString = `<i class="sc-and6 sc-and6-chevron-left text-white"></i>`;
      let options = {
        index,
        arrowPrevSVG: rightArrowSVGString,
        arrowNextSVG: leftArrowSVGString,
        dataSource: [],
        pswpModule: PhotoSwipe,
        wheelToZoom: true,
        tapAction: 'zoom',
        doubleTapAction: false,
        showHideAnimationType: 'none',
      };
      $(this)
        .closest('.carousel-section')
        .find('div.photo-item.slick-slide:not(.slick-cloned) img')
        .each(function (ind, el) {
          let src = $(el)
            .attr('src')
            .replace('profile_s', 'profile')
            .replace('thumb_560', 'profile');
          let width = $(el).attr('data-width');
          let height = $(el).attr('data-height');
          options.dataSource.push({
            src,
            alt: '',
            width,
            height,
          });
        });

      const pswp = new PhotoSwipeLightbox(options);
      pswp.init();
      pswp.loadAndOpen(index);
      pswp.on('close', () => {
        $(this)
          .closest('#photos-carousel')
          .slick('slickGoTo', +pswp.pswp.currIndex);
      });
    });
  };

  Sceon.CompanyProfile.InitPhotoViewer();
});
